import React from 'react';
import NavigationMenu from 'src/components/common/NavigationMenu/NavigationMenu';
import { Box, Container } from '@mui/material';
import './LayoutContainer.scss';
import { PAGE_INFO } from 'src/util/constants';
import dayjs from 'dayjs';
import { APP_VERSION } from 'src/version';
import { useLayoutContainerContext } from './LayoutContext';
import { Outlet, useLocation } from 'react-router-dom';
import { FmtpPage } from 'src/components/common/NavigationMenu/types';
import { ReportsContextProvider } from 'src/components/Views/Reports/ReportsContext';
import { parcelSearchV2Enabled } from 'src/util/featureFlags';

const version = APP_VERSION;

declare module 'notistack' {
    interface VariantOverrides {
        loading: true;
    }
}

export default function LayoutContainer() {
    const { isAutoFillHeightDisabled } = useLayoutContainerContext();
    const location = useLocation();
    const { pathname } = location;

    const selectedNavItem = Object.values(PAGE_INFO).find((page: FmtpPage) => page.href === pathname) ?? { name: '' };

    return (
        <ReportsContextProvider>
            <Box id="main-container">
                <NavigationMenu selectedNavItem={selectedNavItem.name} />
                <Container
                    id="main-content-container"
                    component="main"
                    className={`${isAutoFillHeightDisabled ? 'no-fill' : ''}`}
                >
                    <Outlet />
                </Container>

                <Box id="footer-container" component="footer">
                    &copy; {dayjs().year()} {'Lanter Delivery Systems, LLC'}&reg; &nbsp;{' '}
                    {version ? `v${version}-${parcelSearchV2Enabled ? 2 : 1}` : ''}
                </Box>
            </Box>
        </ReportsContextProvider>
    );
}
